import {
    iconEmployeesCredits,
    iconReports,
    iconReportsDefault,
    iconDocs,
    DocsDesembolsados,
    iconCalculator,
} from '../defaultValues';

const data = {
    role_aee81d56a2784a628bc51ae6dedb06c4: [
        {
            id: 'gogo2',
            icon: iconEmployeesCredits,
            label: 'Creditos Empleados',
            to: '/app/employees',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/reports',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'documents',
                    icon: DocsDesembolsados,
                    label: 'Desembolsados',
                    to: '/app/employees/HumansDocuments',
                },
            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculatorEmployee',
        },
    ],
};
export default data;
